module.exports = __webpack_public_path__ + "img/check-save.147beafa.svg";